// extracted by css-extract-rspack-plugin
export default {"embedContainer":"_1eAuL5i7kux78_TCHxShsi","tabsContainer":"iL3CWMGwhoGeoX4u17G7j"};